import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import {
  ApiClientService,
  ApiResponse
} from '../../shared/services/api-client.service';
import { AB_API_LOCAL_FROM_ACCOUNTS_ENDPOINT } from './../../shared/constants';
import { ICurrency } from './../../shared/interfaces/currency.interface';

interface ITransferOptions {
  billTransferAllowed: boolean;
  bulkTransferAllowed: boolean;
  internationalTransferAllowed: boolean;
  domesticTransferAllowed: boolean;
  internalTransferAllowed: boolean;
}

interface IAccountTransferPermissions {
  internalTransferEnabled: boolean;
  billTransferEnabled: boolean;
  internationalTransferEnabled: boolean;
  domesticTransferEnabled: boolean;
}

interface IAccount {
  accountId?: string;
  availableBalance?: ICurrency;
  portfolioName?: string;
  accountName?: string;
  accountNumber?: string;
  transferOptions?: ITransferOptions;
  accountCreateTransfersPermissions?: IAccountTransferPermissions;
  isFromToAccount?: boolean;
  alias?: string;
  description?: string;
  isDefaultAccount?: boolean;
}

interface InternalAccountsResponse extends ApiResponse {}

@Injectable({
  providedIn: 'root'
})
export class InternalAccountsService extends ApiClientService {
  constructor(http: HttpClient) {
    super(http, AB_API_LOCAL_FROM_ACCOUNTS_ENDPOINT);
  }

  getAccounts(): Observable<any> {
    return this.get();
  }

  public isOnly(
    transferOptions: ITransferOptions,
    transferOption: string
  ): boolean {
    const options = [],
      transferOptionsMap = Object.keys(transferOptions);

    transferOptionsMap.forEach(option => {
      if (option.indexOf('bulk') !== -1) {
        return;
      }

      if (option === transferOption) {
        options.push(transferOptions[option]);
      } else {
        options.push(transferOptions[option] === false);
      }
    });
    return options.every(bool => bool);
  }
}

export {
  IAccount,
  InternalAccountsResponse,
  IAccountTransferPermissions,
  ITransferOptions
};
